import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

import { Textarea } from './../../models/editors/textarea.model';

import { Validators } from '@angular/forms';
import { ContainedFormFields } from './../../models/editors/contained-form-fields.model';
import { BookingOffer } from './../../models/bookings/bookings.model';
import { CommunicationService } from './../../shared/services/communication.service';


@Component({
  selector: 'swb-booking-offer-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class BookingOfferDetailComponent extends FormDetailBase<BookingOffer> implements OnInit, OnDestroy {

  public url = 'booking-offers';
  protected _redirect = './bookings';

  public entity = new BookingOffer({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název nabídky',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Popisek',
        isMultilang: true,
        wysiwyg: true
      }),
      new Textbox({
        key: 'min_days',
        label: 'Minimální počet dnů rezervace',
        validators: [Validators.required],
        type: 'number',
        defaultValue: 1
      }),
      new Textbox({
        key: 'email',
        label: 'E-mail, kam posílat notifikace',
        validators: [Validators.required],
        type: 'email'
      }),
      new ContainedFormFields({
        key: 'booking_formfields',
        label: 'Formulářová pole',
        validators: [],
        containedMultilang: true
      })
    ];
  }

  protected _saveCallback = () => {
    this._communicationService.reloadSublists();
  }


  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _communicationService: CommunicationService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

  protected _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
    this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
    this.isInitialized = true;

  }

  public ngOnDestroy(): void {
    // TODO: do something
  }

}
